export const blurLastInput = (e: any) => {
  if (e.key === 'Enter') {
    e.preventDefault()
    e.target.blur()
  }
}
